import OPERATORS from 'tbase/constants/filterOperators'; // TAKEN FROM DSE

export var USER_TYPES = {
  INTERNAL_USER: 1,
  CDMS_USER: 2,
  CDK_USER: 3,
  RNR_USER: 4,
  SAP_USER: 5
};
export var USER_AVAILABILITY = {
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable'
};
export var USER_TYPES_OPTIONS = [{
  label: __('Internal User'),
  value: USER_TYPES.INTERNAL_USER
}, {
  label: __('CDMS'),
  value: USER_TYPES.CDMS_USER
}, {
  label: __('CDK'),
  value: USER_TYPES.CDK_USER
}, {
  label: __('RnR'),
  value: USER_TYPES.RNR_USER
}, {
  label: __('SAP'),
  value: USER_TYPES.SAP_USER
}];
export var ACTIVE_USER_FILTER = {
  field: 'active',
  operator: OPERATORS.IN,
  values: [true],
  key: 'active'
};
export var ARC_USER_FILTER = {
  field: 'type',
  operator: OPERATORS.IN,
  values: [USER_TYPES.CDMS_USER],
  key: 'type'
};